import {createApp} from 'vue';
import AddToCart from '../vue/add-to-cart/AddToCart.vue';

document.querySelectorAll( '.whippet-add-to-cart' ).forEach( widget => {
	createApp( AddToCart, widget.dataset ).mount( widget );
} );
